(() => {
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const hydrate = (card) => {
    const template = card?.querySelector('template[data-hover-media]');
    if (!template || card.dataset.hoverState) return;
    card.dataset.hoverState = 'loading';
    const fragment = template.content.cloneNode(true);
    const image = fragment.querySelector('img');
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = 'low';
    image.decoding = 'async';
    const fail = () => {
      card.dataset.hoverState = 'error';
      card.removeAttribute('data-hover-ready');
      image.remove();
    };
    const ready = async () => {
      try { if (image.decode) await image.decode(); } catch { fail(); return; }
      if (!image.naturalWidth) { fail(); return; }
      card.dataset.hoverState = 'ready';
      card.setAttribute('data-hover-ready', '');
    };
    image.addEventListener('load', ready, { once: true });
    image.addEventListener('error', fail, { once: true });
    template.replaceWith(fragment);
    if (image.complete) image.naturalWidth ? ready() : fail();
  };
  document.addEventListener('pointerover', (event) => {
    if (hover.matches) hydrate(event.target.closest('[data-hover-card]'));
  });
  document.addEventListener('focusin', (event) => hydrate(event.target.closest('[data-hover-card]')));
})();
